import React from 'react';
import { IQuestionTwo } from '../types/get-started.type';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Icon, Icons } from 'components/Icon';
import ProgressBar from 'components/ProgressBar';
import Question from './Question';
import Button from 'components/Form/Button';
import { quetionsTwo } from 'constants/survey';

type Props = {
  onSubmit: (formValue: IQuestionTwo) => void;
};

export default function QuestionTwo({ onSubmit }: Props) {
  const formik = useFormik({
    initialValues: {
      doYouHaveEmployeeBenefit: '',
      doYouHaveBankAccount: '',
      doYouHaveBondShare: '',
      doYouHaveAsset: '',
      doYouHaveSpecialInstruction: '',
      doYouNeedTrustee: ''
    },
    validationSchema: Yup.object({
      doYouHaveEmployeeBenefit: Yup.string().required(
        'Do you have employee benefits is required'
      ),
      doYouHaveBankAccount: Yup.string().required(
        'Do you have bank accounts is required'
      ),
      doYouHaveBondShare: Yup.string().required(
        'Do you have bonds, stocks or shares is required'
      ),
      doYouHaveAsset: Yup.string().required(
        'Do you have other assets is required'
      ),
      doYouHaveSpecialInstruction: Yup.string().required(
        'Tell us if you have any special instructions'
      ),
      doYouNeedTrustee: Yup.string().required(
        'Do you need to appoint a trustee is required'
      )
    }),
    onSubmit: (values, { setFieldTouched }) => {
      for (const key in values) {
        setFieldTouched(key, true);
      }
      onSubmit(values);
    }
  });

  const handleChange = (fieldName: string, fieldValue: boolean | string) => {
    formik.setFieldValue(fieldName, fieldValue);
  };

  return (
    <div className="mx-20 my-16 flex flex-col items-center ">
      <p className="w-[60%] text-center text-4xl font-medium text-[#353535]">
        Just some questions to help us advise the kind of will that makes sense
        for you.
      </p>
      <div className="my-10 w-[50%]">
        <ProgressBar percentage={100} />
      </div>
      <form
        autoComplete="false"
        className="flex flex-col items-center text-center"
        onSubmit={formik.handleSubmit}
      >
        {quetionsTwo.map(question => {
          const error = (formik.errors as { [key: string]: string })[
            question.fieldName
          ];
          const value = (formik.values as { [key: string]: string })[
            question.fieldName
          ];
          return (
            <Question
              key={question.id}
              question={question.question}
              fieldName={question.fieldName}
              error={error}
              handleChange={handleChange}
              fieldValue={value}
            />
          );
        })}
        <Button
          variant="primary"
          size="md"
          iconPosition="right"
          icon={<Icon name={Icons.ArrowRight} />}
          className="mt-12 w-[15rem] rounded border-[#353535] p-[0.1rem]"
          label="COMPLETE"
          type="submit"
        ></Button>
      </form>
    </div>
  );
}
